import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'terms' | 'privacy' | null;
const modalContent: Record<'terms' | 'privacy', {
  title: string;
  body: React.ReactNode;
}> = {
  terms: {
    title: 'Términos y Condiciones',
    body: <div className="space-y-4 text-brown-light text-sm leading-relaxed" data-id="element-49">
        <p data-id="element-50">
          <strong className="text-brown" data-id="element-51">1. Aceptación de los Términos</strong>
          <br data-id="element-52" />
          Al adquirir y utilizar la guía "Acuerdos Express", aceptas estos
          términos y condiciones en su totalidad.
        </p>

        <p data-id="element-53">
          <strong className="text-brown" data-id="element-54">2. Producto Digital</strong>
          <br data-id="element-55" />
          "Acuerdos Express" es un producto digital descargable. Una vez
          completada la compra, recibirás acceso inmediato al contenido. Debido
          a la naturaleza digital del producto, no se aceptan devoluciones una
          vez descargado.
        </p>

        <p data-id="element-56">
          <strong className="text-brown" data-id="element-57">3. Uso Personal</strong>
          <br data-id="element-58" />
          La guía es para uso personal y familiar. No está permitida su
          redistribución, reventa, copia o compartición pública del contenido
          sin autorización expresa.
        </p>

        <p data-id="element-59">
          <strong className="text-brown" data-id="element-60">4. Propiedad Intelectual</strong>
          <br data-id="element-61" />
          Todo el contenido de "Acuerdos Express" está protegido por derechos de
          autor. Los textos, plantillas, guiones y materiales son propiedad
          exclusiva de sus creadores.
        </p>

        <p data-id="element-62">
          <strong className="text-brown" data-id="element-63">
            5. Limitación de Responsabilidad
          </strong>
          <br data-id="element-64" />
          Esta guía ofrece herramientas prácticas para mejorar la comunicación
          en pareja durante la crianza. No sustituye asesoramiento profesional,
          terapia de pareja ni atención psicológica.
        </p>

        <p data-id="element-65">
          <strong className="text-brown" data-id="element-66">6. Modificaciones</strong>
          <br data-id="element-67" />
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios serán efectivos desde su publicación.
        </p>
      </div>
  },
  privacy: {
    title: 'Política de Privacidad',
    body: <div className="space-y-4 text-brown-light text-sm leading-relaxed" data-id="element-68">
        <p data-id="element-69">
          <strong className="text-brown" data-id="element-70">1. Información que Recopilamos</strong>
          <br data-id="element-71" />
          Al realizar tu compra, recopilamos únicamente la información necesaria
          para procesar el pago y entregar el producto: nombre y correo
          electrónico.
        </p>

        <p data-id="element-72">
          <strong className="text-brown" data-id="element-73">2. Uso de la Información</strong>
          <br data-id="element-74" />
          Tu información se utiliza exclusivamente para:
          <br data-id="element-75" />
          • Procesar y entregar tu compra
          <br data-id="element-76" />
          • Enviarte el acceso al producto
          <br data-id="element-77" />• Comunicaciones relacionadas con tu compra
        </p>

        <p data-id="element-78">
          <strong className="text-brown" data-id="element-79">3. Protección de Datos</strong>
          <br data-id="element-80" />
          Implementamos medidas de seguridad para proteger tu información
          personal. No almacenamos datos de tarjetas de crédito; los pagos son
          procesados de forma segura por nuestro proveedor de pagos.
        </p>

        <p data-id="element-81">
          <strong className="text-brown" data-id="element-82">
            4. No Compartimos tu Información
          </strong>
          <br data-id="element-83" />
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. Tu privacidad es nuestra prioridad.
        </p>

        <p data-id="element-84">
          <strong className="text-brown" data-id="element-85">5. Cookies</strong>
          <br data-id="element-86" />
          Nuestro sitio puede utilizar cookies para mejorar la experiencia de
          navegación. Puedes desactivarlas en la configuración de tu navegador.
        </p>

        <p data-id="element-87">
          <strong className="text-brown" data-id="element-88">6. Tus Derechos</strong>
          <br data-id="element-89" />
          Puedes solicitar la eliminación de tus datos personales en cualquier
          momento escribiéndonos por correo electrónico.
        </p>
      </div>
  }
};
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-12 bg-brown text-cream/60 text-center" data-id="element-90">
        <div className="max-w-6xl mx-auto px-4" data-id="element-91">
          <p className="font-serif text-xl text-cream mb-4" data-id="element-92">Acuerdos Express</p>
          <p className="text-sm mb-8" data-id="element-93">
            &copy; {new Date().getFullYear()} Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6 text-xs uppercase tracking-widest" data-id="element-94">
            <button onClick={() => setActiveModal('terms')} className="hover:text-terracotta transition-colors cursor-pointer" data-id="element-95">
              Términos
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-terracotta transition-colors cursor-pointer" data-id="element-96">
              Privacidad
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-97">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-brown/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-98">
            <motion.div initial={{
          opacity: 0,
          scale: 0.92,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.92,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="bg-cream rounded-2xl shadow-2xl max-w-lg w-full max-h-[80vh] overflow-hidden border border-blush/20" onClick={e => e.stopPropagation()} data-id="element-99">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-5 border-b border-blush/20" data-id="element-100">
                <h3 className="text-lg font-bold text-brown" data-id="element-101">
                  {modalContent[activeModal].title}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-brown-light hover:text-terracotta transition-colors p-1 rounded-full hover:bg-terracotta/10 cursor-pointer" data-id="element-102">
                  <X className="w-5 h-5" data-id="element-103" />
                </button>
              </div>

              {/* Content */}
              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-70px)]" data-id="element-104">
                {modalContent[activeModal].body}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}